var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSideBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.067 10.442l-6.25 6.25a.625.625 0 11-.884-.884L9.742 10l-5.81-5.808a.625.625 0 01.885-.884l6.25 6.25a.626.626 0 010 .884zm6.25-.884l-6.25-6.25a.625.625 0 00-.884.884L15.992 10l-5.81 5.808a.625.625 0 10.885.884l6.25-6.25a.625.625 0 000-.884z",
    fill: "currentColor"
  })));
}
export default SvgCloseSideBar;